<div class="row space-between">
  <form [formGroup]="searchInput">
    <mat-form-field class="search-input">
      <div class="row">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input
          placeholder="{{ 'GrantManagementComponent.searchGrants' | translate }}"
          matInput
          type="text"
          (change)="search()"
          formControlName="searchText"
        />
      </div>
    </mat-form-field>
  </form>
  <button mat-raised-button color="primary" (click)="openCreateGrantDialog()">
    {{ 'CreateGrantComponent.createGrant' | translate }}
  </button>
</div>

<ng-dynamic-http-table
  #grantTable
  [crudClass]="grantService"
  [displayedColumnsObject]="myColumns"
  [mode]="'table'"
  [showSearch]="false"
  [pageSize]="10"
>
</ng-dynamic-http-table>
